// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resetPasswordStyles } from "@awc/Overrides/Widgets/ResetPassword/ResetPassword";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

resetPasswordStyles.instructionsText = {
    as: "h4",
    variant: "h4",
    css: css`
        margin-bottom: 16px;
    `,
};

resetPasswordStyles.passwordGridContainer = {
    gap: 24,
};

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 12, 7, 7],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

resetPasswordStyles.requirementsGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        flex-direction: column;
    `,
};

resetPasswordStyles.mainGridContainer = {
    gap: 20,
};

resetPasswordStyles.submitButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

resetPasswordStyles.requirementsWrapper = {
    css: css`
        ${styledBoxStyle}
    `,
};

resetPasswordStyles.newPasswordTextField = resetPasswordStyles.confirmNewPasswordTextField = {
    labelProps: {
        css: css`
            width: 40%;
            text-align: left;
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex-grow: 1;
        `,
        formField: css`
            align-items: start;
        `,
    },
};
